<ng-container *ngIf="step === 'module'">
  <div class="form-grid">
    <sh-field
      class="field-wide"
      label="uiModules.wizard.organizations"
      [required]="true"
    >
      <sh-select
        [options]="organisations"
        optionLabel="name"
        optionValue="id"
        [filter]="true"
        [showClear]="true"
        [value]="seahorseModule.organisationId"
        (valueChange)="setOrganisation($event)"
      ></sh-select>
    </sh-field>
    <sh-field class="field-wide" label="seahorse.object" [required]="true">
      <sh-select
        [options]="seahorseObjects"
        optionLabel="name"
        optionValue="mappingKey"
        [filter]="true"
        [showClear]="true"
        [disabled]="!seahorseModule.organisationId"
        [value]="seahorseModule.mappingKey"
        (valueChange)="setMappingKey($event)"
      ></sh-select>
    </sh-field>
  </div>

  <div class="setting-list mt-4">
    <div class="setting-group">
      <div class="setting-row">
        <sh-toggle
          [(value)]="hasOverviewConfiguration"
          ariaLabel="uiModules.wizard.hasOverviewConfiguration"
        ></sh-toggle>
        <div class="setting-text">
          <div class="setting-name">
            {{ 'uiModules.wizard.hasOverviewConfiguration' | translate }}
          </div>
        </div>
      </div>
      <div class="setting-row">
        <sh-toggle
          [(value)]="seahorseModule.isActive"
          ariaLabel="shared.statuses.active"
        ></sh-toggle>
        <div class="setting-text">
          <div class="setting-name">
            {{ 'shared.statuses.active' | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="step === 'overview'">
  <div class="setting-list mb-3">
    <div class="setting-group">
      <div class="setting-group-title">
        {{ 'uiModules.wizard.overviewConfiguration' | translate }}
      </div>
    </div>
  </div>

  <su-ui-module-overview-configuration-form
    [seahorseModule]="seahorseModule"
    [configuration]="seahorseModule.overviewConfiguration"
  ></su-ui-module-overview-configuration-form>
</ng-container>

<sh-dialog-footer>
  <sh-button
    label="shared.terms.cancel"
    variant="text"
    (click)="dialogRef.cancel()"
  ></sh-button>
  <sh-button
    *ngIf="!isFirst"
    label="shared.terms.back"
    severity="secondary"
    (click)="back()"
  ></sh-button>
  <sh-button
    *ngIf="!isLast"
    label="shared.terms.next"
    [disabled]="!isStepValid"
    (click)="next()"
  ></sh-button>
  <sh-button
    *ngIf="isLast"
    label="shared.terms.save"
    [disabled]="!isStepValid || saveStarted"
    [loading]="saveStarted"
    (click)="save()"
  ></sh-button>
</sh-dialog-footer>
